const play = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M6.54076%202.15882L20.5408%2011.1588C21.1531%2011.5525%2021.1531%2012.4475%2020.5408%2012.8412L6.54076%2021.8412C5.87525%2022.269%205%2021.7912%205%2021V3C5%202.20883%205.87525%201.73099%206.54076%202.15882ZM7%204.83167V19.1683L18.1507%2012L7%204.83167Z'/%3e%3c/svg%3e";
export {
  play as default
};
//# sourceMappingURL=play.svg.es.js.map
